<template>
    <section :class="['cabecera', porlet.attr.mode || 'light']">
        <h1>{{ficha.attr.title || 'Ficha'}}</h1>
       
        <div class="cabecera-left">
            <slot name="MenuActions"></slot>

            <el-tag v-if="ficha.attr.estado">{{ficha.attr.estado}}</el-tag>
            
            <slot name="OpenDrawerLeft"></slot>
            <slot name="OpenDrawerRight"></slot>

        </div>
    </section>
</template>

<script>
	export default {
        name: 'Cabecera',
        props: {
            id: [Number,String],
            ficha: Object,
            entidad: String,
            porlet: Object
        }
	}
</script>

<style lang="scss">
.cabecera {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 10px 15px;
    border-bottom: 1px solid #e5e5e573;
    &.dark {
        background-color: #2c2c2c;
        color: white;
    }
    &.light {
        background-color: white;
    }
    h1 {
        font-size: 1.2rem;
        margin: 0px;
        font-weight: 500;
        span {
            margin-left: 10px;
        }
    }
    h4 {
        font-size: 1.5rem;
        margin: 0px 0px 5px 0px;
        font-weight: 500;
        display: flex;
    }
    
    .cabecera-left {
        display: flex;
        align-items: center;
        span.estado {
            background-color: #4a596a;
            padding: 3px 12px 3px 12px;
            color: white;
            border-radius: 3px;
            font-size: 0.7rem;
            width: fit-content;
        }
        .el-tag {
            font-family: Arial;
            margin: 0px 10px;
        }
    }
}
</style>